import { t } from '@/plugins/i18n'
export const sellPriceDict = [
  { label: t('全部'), value: '' },
  { label: t('0-10元'), value: '0,10' },
  { label: t('10-20元'), value: '10,20' },
  { label: t('20-30元'), value: '20,30' },
  { label: t('30-50元'), value: '30,50' },
  { label: t('50-100元'), value: '50,100' },
  { label: t('100-150元'), value: '100,150' },
  { label: t('200-300元'), value: '200,300' },
  { label: t('300元以上'), value: '300,' }
]

export const channelDict = [
  { label: t('全部'), value: '' },
  { label: t('市场购'), value: '1' },
  { label: t('透明购'), value: '2' },
  { label: t('我的OEM商品'), value: '3' },
  { label: t('我的组合商品'), value: '4' },
  { label: t('我收藏的商品'), value: '5' }
]
